import { useAuth } from "../../contexts/AuthContext";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./index.css";
// import log_menu from "./assets/log-menu.png";
/* import usuario from './assets/usuario.png' */
// import modo_dia from "./assets/modoo-dia.png";
// import modo_noche from "./assets/modo-noche.png";
// import logo_color from "../../assets/logo_colors.png";
import menu from "./assets/list.svg";
import watch from "./assets/stopwatch-fill.svg";
import iconoAyuda from "../../assets/icons/icono_ayuda_naranjo.png";
import iconoAyudaBlanco from "../../assets/icons/icono_ayuda_blanco.png";
import React from "react";
import iconoInicio from "../../assets/icons/icono_inicio.png";
import iconoProgreso from "../../assets/icons/icono_progreso.png";
import iconoCapacitaciones from "../../assets/icons/icono_capacitaciones.png";
import { CustomDialog } from "../../components/Dialog";
import { useTheme } from "../../contexts/ThemeContext";
import { SenceValidation } from "../../services/sence";
import { useTimer } from "../Timer";
// import { THEME_CONTEXT } from "../../utils/theme";
import { LIMIT_CRON_AVG } from "../../utils/state";
import { Snackbar } from "../../components/Snackbar";
import { DEFAULT_SNACKBAR, SENCE_WARNING } from "../../utils/snackbar";
import LogoutIcon from "@mui/icons-material/Logout";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { IconButton } from "@mui/material";
import { useMoodleV2 } from "../../contexts/moodle";
import { useConfig } from "../../contexts/config";
import { Sidebar } from "../Sidebar";
import { darken, readableColor } from "polished";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import StarIcon from "@mui/icons-material/Star";
import { useIsMobile } from "../../hooks/useIsMobile";

/* to work on */
export const Navbar = ({ layout, handleContentLayout }) => {
  const { time, limit } = useTimer();
  const auth = useAuth();
  const { lang } = useAuth();
  const { config } = useConfig();
  const theme = useTheme();
  const navref = React.useRef(null);
  const isSence = localStorage.getItem("sence_session");
  const [snackbar, setSnackbar] = React.useState(DEFAULT_SNACKBAR);
  const [open, setOpen] = React.useState(false);
  // const icon = theme.mode === "light" ? modo_dia : modo_noche;
  // const [sidebar, toggleSidebar] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const moodlev2 = useMoodleV2();

    const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [helpActive, setHelpActive] = React.useState(false);
  const isMobile = useIsMobile();

    const toggleDrawer = (isOpen) => {
      setDrawerOpen(isOpen);
    };

  React.useEffect(() => {
    if (limit > LIMIT_CRON_AVG) {
      handleSenceLogout();
      localStorage.removeItem("last_login_sence");
      localStorage.removeItem("sence_session");
      localStorage.removeItem("current_course");
      localStorage.removeItem("idSence");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time]);

 /*  React.useEffect(() => {
    lang && console.log(lang["Navbar"]);
  }, [lang]); */

  const handleLogout = () => {
    setOpen(true);
  };
  const handleLogoutCompleted = () => {
    setOpen(false);
    localStorage.removeItem("sence_validated");
    auth.logout(moodlev2);
    navigate("/");
  };

  const handleDarkMode = () => {
    theme.actions.handleDarkMode();
  };

  const handleSenceLogout = () => {
    let id = localStorage.getItem("idSence");
    if (!id) {
      return;
    }
    let sence = JSON.parse(localStorage.getItem("sence_session"));
    let nru = localStorage.getItem("nru");
    let validation = {
      idSence: id,
      auth,
      session: sence,
      isLogin: false,
      nru,
    };
    /*     console.log(sence) */
    localStorage.removeItem("sence_validated"); // ! por ahora se asume que sencevalidation para cerrar sesión es exitoso, por lo que se borra el flag. pero esto es temporal por la urgencia.
    SenceValidation(validation);
  };

  let disabled = {
    pointerEvents: isSence ? "none" : "",
    opacity: isSence ? 0.5 : 1,
  };

  let timer = null;

/*   const handleSenceWarning = () => {
    if (!isSence) {
      return;
    }
    if (timer != null) {
      clearTimeout(timer);
      timer = null;
      return;
    } else {
      timer = setTimeout(closeSenceWarning, 2000);
      setSnackbar(SENCE_WARNING);
      return;
    }
  }; */

/*   const closeSenceWarning = () => {
    setTimeout(() => {
      setSnackbar(DEFAULT_SNACKBAR);
    }, 2000);
  };
 */
  // const handleSidebar = () => {
  //   let { style } = document.querySelector(".sidebar-container");
  //   if (!sidebar) {
  //     style.left = "0";
  //     return toggleSidebar(!sidebar);
  //   }

  //   style.left = "-350px";
  //   toggleSidebar(!sidebar);
  // };

  return (
    <>
      {lang && (
        <nav ref={navref} style={{backgroundColor:theme.colors.backgroundColorNavBar}} className={isMobile ? "h-[45px]" : "h-[90px]"}>
          <div
            className="nav_block"
/*             onMouseEnter={handleSenceWarning}
            onMouseLeave={handleSenceWarning} */
          >
            <div className="logo px-4">
              <img
                alt="img"
                src={
                  config.config.theme && (theme && theme.mode === "light" ? config.config.theme.logo : config.config.theme.theme_logo_dark)
                }
                width={isMobile ? 120 : 220}
                /*  style={{ transform: "translateY(-5px)" }} */
                onClick={() => navigate("/listcourses")}
              />
            </div>
            <div className="list">
              <ul className="navlist" datatoggle="tooltip">
                <Link to={"/listcourses"} style={disabled}>
                  <li
                    className={`nav-pill-btn${location.pathname === "/listcourses" ? " active" : ""}`}
                  >
                    <img src={iconoInicio} alt="" style={{ width: isMobile ? 14 : 20, height: isMobile ? 14 : 20 }} />
                    {lang["Navbar"].home}
                  </li>
                </Link>
                <Link to={"/listcourses/progress"} style={disabled}>
                  <li
                    className={`nav-pill-btn${location.pathname === "/listcourses/progress" ? " active" : ""}`}
                  >
                    <img src={iconoProgreso} alt="" style={{ width: isMobile ? 14 : 20, height: isMobile ? 14 : 20 }} />
                    {lang["Navbar"].history}
                  </li>
                </Link>
                {config.opciones.includes("contacto") && (
                  <Link to={"/contact"} style={disabled}>
                    <li
                      className={`nav-pill-btn${location.pathname === "/contact" ? " active" : ""}`}
                    >
                      <img src={iconoCapacitaciones} alt="" style={{ width: isMobile ? 14 : 20, height: isMobile ? 14 : 20 }} />
                      {lang["Navbar"].contact}
                    </li>
                  </Link>
                )}
                <Link to={"/gamification"} style={disabled}>
                  <li
                    className={`nav-pill-btn${location.pathname === "/gamification" ? " active" : ""}`}
                  >
                    <EmojiEventsIcon style={{ width: isMobile ? 14 : 20, height: isMobile ? 14 : 20, color: "#facc15" }} />
                    Ranking
                  </li>
                </Link>
              </ul>
            </div>
          </div>
          <div className="nav_block">
            <div className="row menu">
              <button
                className={`help-btn${helpActive ? " active" : ""}`}
                onClick={() => window.dispatchEvent(new Event("open-tutorial"))}
                onMouseDown={() => setHelpActive(true)}
                onMouseUp={() => setHelpActive(false)}
                onMouseLeave={() => setHelpActive(false)}
                onTouchStart={() => setHelpActive(true)}
                onTouchEnd={() => setHelpActive(false)}
                aria-label="Ayuda"
                style={isMobile ? { width: 25, height: 25 } : undefined}
              >
                <img src={helpActive ? iconoAyudaBlanco : iconoAyuda} alt="Ayuda" />
              </button>
              <button
                className={`hamburger-btn${drawerOpen ? " open" : ""}`}
                onClick={() => toggleDrawer(!drawerOpen)}
                aria-label="Menú"
                aria-expanded={drawerOpen}
              >
                <span className="hamburger-line line-1"></span>
                <span className="hamburger-line line-2"></span>
                <span className="hamburger-line line-3"></span>
              </button>
            </div>
            {isSence && (
              <div
                className="student_profile stopwatch"
                style={{
                  cursor: "pointer",
                  justifyContent: "space-between",
                  //backgroundColor: THEME_CONTEXT.DAY_MODE_BTN,
                  borderRadius: "10px",
                  margin: "10px",
                  padding: "7px 10px",
                  backgroundColor:theme.mode === "light" ? theme.colors.button_light :  theme.colors.button_dark ,
                }}
                onClick={handleSenceLogout}
              >
                <img src={watch} alt="..." />
                <p style={{color:theme.mode === "light" ? readableColor(darken(0.2,theme.colors.backgroundColorNavBar)) :  readableColor(theme.colors.backgroundColorNavBar)}} className="font-semibold text-2xl p-2 rounded-md">{time}</p>
                <p className="font-semibold text-2xl p-2 rounded-md" style={{backgroundColor:
                    theme.mode === "light"
                      ? theme.colors.tertiary_light
                      : theme.colors.primary_light,color:theme.mode === "light" ? readableColor(darken(0.2,theme.colors.backgroundColorNavBar)) :  readableColor(theme.colors.backgroundColorNavBar)}}>Cerrar Sesión Sence</p>
              </div>
            )}

            {window.location.pathname.includes("detailcourse") && (
              <div
                className="student_profile menu-handler-button"
                style={{
                  margin: 0,
                  transform: layout ? "rotate(180deg)" : "rotate(0deg)",
                  backgroundColor:
                    theme.mode === "light"
                      ? theme.colors.tertiary_light
                      : theme.colors.primary_light,
                }}
              >
                <IconButton
                  onClick={handleContentLayout}
                  sx={{ padding: "5px" }}
                >
                  {layout ? (
                    // <KeyboardArrowRightIcon
                    //   sx={{
                    //     color: theme.mode === "light" ? "#fff" : "#fff",
                    //     fontSize: 30,
                    //   }}
                    // />
                    <MenuOpenIcon
                      sx={{
                        color: theme.mode === "light" ? "#fff" : "#fff",
                        fontSize: isMobile ? 22 : 35,
                      }}
                    />
                  ) : (
                    // <KeyboardArrowLeftIcon
                    //   sx={{
                    //     color: theme.mode === "light" ? "#fff" : "#fff",
                    //     fontSize: 30,
                    //   }}
                    // />
                    <MenuOpenIcon
                      sx={{
                        color: theme.mode === "light" ? "#fff" : "#fff",
                        fontSize: isMobile ? 22 : 35,
                      }}
                    />
                  )}
                </IconButton>
              </div>
            )}

            <Link to="/gamification" style={{ textDecoration: "none", display:"none" }}>
              <div
                className="gamification-points-badge flex items-center gap-2 rounded-full px-3 py-1 cursor-pointer hover:brightness-110 transition-all"
                style={{
                  backgroundColor: theme.mode === "light" ? "#fef9c3" : "#854d0e40",
                  border: "1px solid #facc1550",
                }}
              >
                <StarIcon sx={{ fontSize: 20, color: "#facc15" }} />
                <span className="text-xl font-bold" style={{ color: theme.mode === "light" ? "#854d0e" : "#facc15" }}>
                  3.100
                </span>
              </div>
            </Link>

            <div className="student_profile">
              <p style={{ color: theme.colors.textColorNavbar }}>
                {auth && auth.user?.fullname}
              </p>
              <img
                alt="img"
                src={auth.user.profileimageurlsmall}
                style={{ borderRadius: "50%" }}
              />
            </div>

            <div
              className="modo_dia hidden"
              onClick={handleDarkMode}
              style={{
                backgroundColor: theme.mode === "light" ? "#f5f5f5" : "#333",
              }}
            >
              {theme.mode === "light" ? (
                <>
                  <LightModeIcon sx={{ fontSize: 22, fill: "#2d4662" }} />
                  {/* <LightModeIcon sx={{ fontSize: 22, fill: theme.palette.nav.backgroundColor }} /> */}
                </>
              ) : (
                <DarkModeIcon sx={{ fontSize: 22 }} />
              )}
            </div>
            <div className="logout" onClick={handleLogout}>
              <LogoutIcon
                sx={{
                  fontSize: 30,
                  color: theme.colors.textColorNavbar,
                }}
              />
            </div>
          </div>
          <Snackbar
            message={snackbar.message}
            severity={snackbar.severity}
            visible={snackbar.visible}
          />
          <CustomDialog
            open={open}
            message={lang["Snackbars"].acc_logout_message}
            confirm={lang["Snackbars"].confirm}
            cancel={lang["Snackbars"].cancel}
            sence={isSence}
            onCancel={() => setOpen(false)}
            onConfirm={handleLogoutCompleted}
          />

          <Sidebar isOpen={drawerOpen} onClose={() => toggleDrawer(false)} />
        </nav>
      )}
    </>
  );
};
